import { DEV_MODE } from '../../global/env';
import { Logger } from '../logger';
/**
 * A disposal bin used to add cleanup callbacks that can be called when required.
 */
export class DisposalBin {
    constructor(_host, _options = {}) {
        var _a, _b;
        this._options = _options;
        // @ts-expect-error
        this._disposal = (_a = this._disposal) !== null && _a !== void 0 ? _a : [];
        /* c8 ignore start */
        if (DEV_MODE && _host && _options.name) {
            const className = _options.owner ? ` [${this.constructor.name}]` : '';
            this._logger = new Logger(_host, {
                owner: (_b = _options.owner) !== null && _b !== void 0 ? _b : this,
                name: `🗑️ ${this.name}${className}`
            });
        }
        /* c8 ignore stop */
    }
    get name() {
        return this._options.name;
    }
    add(...callbacks) {
        if (callbacks) {
            callbacks.forEach((cb) => {
                this._disposal.push(cb);
            });
        }
    }
    /**
     * Dispose of callbacks.
     */
    empty() {
        var _a;
        /* c8 ignore start */
        if (DEV_MODE && this.name && this._disposal.length > 0) {
            (_a = this._logger) === null || _a === void 0 ? void 0 : _a.debug('empty', this._disposal.length, 'items');
        }
        /* c8 ignore stop */
        this._disposal.forEach((fn) => fn());
        this._disposal = [];
    }
}
